import { Controller } from "@hotwired/stimulus";

// Duas ou mais leituras do mesmo bloco (total e por filial, uso e saúde), uma visível
// por vez. Cada botão leva `data-alternancia-painel-param` com o id do painel que
// mostra; os painéis são targets e escondem-se pelo atributo `hidden`, que não briga
// com o `display` de nenhuma classe.
export default class extends Controller {
  static targets = ["botao", "painel"];

  mostrar({ params: { painel } }) {
    this.painelTargets.forEach((alvo) => {
      alvo.hidden = alvo.id !== painel;
    });

    this.botaoTargets.forEach((botao) => {
      const ativo = botao.dataset.alternanciaPainelParam === painel;

      botao.classList.toggle("is-ativo", ativo);
      botao.setAttribute("aria-pressed", ativo.toString());
    });

    // O Chart.js mede o pai ao ser exibido; escondido, ele ficou com zero de largura.
    window.dispatchEvent(new Event("resize"));
  }
}
